module.exports = __webpack_public_path__ + "3316556a1981772b32c528b62ab2fd58.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/routes/assessment/assets/doge.jpg
// module id = 195
// module chunks = 0